import { returnsBySectorChartOptions } from '../../../../industry/constants/industryBreakdownStatsElementOptions';
import { StatsElementOptions } from '../../../../../../shared/entities/stats-element/interfaces/StatsElementOptions';

export const returnsBySectorStatsElementOptions: StatsElementOptions = {
  chartsOptions: [returnsBySectorChartOptions],
};
